import { Center, Loader } from '@mantine/core';
import { Navigate, Outlet } from 'react-router-dom';
import { useAuth } from '@/stores/authContext';
import { useIsAgent } from '@/hooks/useRoles';
import { ROUTES } from '@/routes/paths';

// Роут-гард: раздел доступен только роли AGENT. Стоит ВНУТРИ RequireAuth, поэтому аутентификация
// уже гарантирована — проверяем лишь роль. Не-агент уводится на «Главное» (а не 404 — раздел реален,
// просто не его). Бэкенд дублирует запрет (403), это страховка от прямого захода по URL.
export default function RequireAgent() {
  const { isInitializing } = useAuth();
  const isAgent = useIsAgent();

  if (isInitializing) {
    return (
      <Center h="50vh">
        <Loader />
      </Center>
    );
  }
  return isAgent ? <Outlet /> : <Navigate to={ROUTES.APP} replace />;
}
